import Dialog	from "dialog";
import template	from "../html/dialog-settings.html";
import css		from "../css/dialog-settings.css";

import Datatable from "datatable";
import {Label, Textbox} from "gui";

class SettingsDialog extends Dialog {
	static get template() {
		return template;
	}
	static get css() {
		return css;
	}
	static constructor() {
		customElements.define("fulljs-dialog-internalsettings", SettingsDialog);
	}
	constructor() {
		super();

		server.rcall("RM_getSettings").then(function(result) {
			for (var name in result) {
				var row = new Datatable.Row();
				row.appendChild( new Label({value: name, style: "width: 50%;"}) );
				let textbox = row.appendChild( new Textbox({value: result[name], style: "width: 50%;"}) );
              if (name=="device_qups") textbox.disabled = true;
				this.datatableSettings.appendChild(row);
			}

			this.show();
		}.bind(this)).catch(function(result) {
			alert(result);
		}.bind(this));
	}
	buttonClose_click() {
		this.close();
	}
	buttonSave_click() {
		var json = {};
		for (var i=1; i<this.datatableSettings.children.length; i++) {
			json[this.datatableSettings.cell(i, 0).value] = Number(this.datatableSettings.cell(i, 1).value);
		}

		this.buttonSave.icon.iconname = "view-refresh";
		this.buttonSave.disabled = true;
		server.rcall("RM_setSettings", json).then(function(result) {
			this.buttonSave.icon.iconname = "dialog-ok";
			this.buttonSave.disabled = false;
		}.bind(this)).catch(function(result) {
			alert(result);
			this.buttonSave.icon.iconname = "dialog-ok";
			this.buttonSave.disabled = false;
		}.bind(this));
	}
}

SettingsDialog.constructor();

export default SettingsDialog;